export const HELP_CENTRE_LINK = 'https://madpaws.brainfi.sh/';
export const RWB_CANCELLATION_POLICY_LINK = `${HELP_CENTRE_LINK}articles/what-is-the-cancellation-and-refund-policy-for-repeat-weekly-bookings-ysTRx8PNrN`;
